//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
SPLM.CAM.CutParametersSimplifyShapesTypes = Object.freeze({
    "None" : "None", "ConvexHull" : "ConvexHull", "MinimumBox" : "MinimumBox"});

SPLM.CAM.CutParametersTraverseOpenPassesTypes = Object.freeze({
    "Zig" : "Zig", "ZigZag" : "ZigZag"});

SPLM.CAM.CutParametersCutOrderTypes = Object.freeze({
    "LevelFirst" : "LevelFirst", "DepthFirst" : "DepthFirst", "DepthFirstAlways" : "DepthFirstAlways"});

SPLM.CAM.CutParametersTrimBehaviorTypes = Object.freeze({
    "Default" : "Default", "NcmTrimmed" : "NcmTrimmed", "FollowBoundary" : "FollowBoundary"});

SPLM.CAM.CutParametersRegionSequencingTypes = Object.freeze({
    "Standard" : "Standard", "Optimize" : "Optimize", "RegionPoints" : "RegionPoints", "PredrillPoints" : "PredrillPoints"});

SPLM.CAM.CutParametersTrimControlTypes = Object.freeze({
    "None" : "None", "Silhoutte" : "Silhoutte", "ExteriorEdges" : "ExteriorEdges"});

SPLM.CAM.CutParametersPlungeDirectionTypes = Object.freeze({
    "CutDown" : "CutDown", "UpAndDown" : "UpAndDown"});

SPLM.CAM.CutParametersActionWhenGougingTypes = Object.freeze({
    "Warning" : "Warning", "Skip" : "Skip", "Retract" : "Retract", "Tilt" : "Tilt"});

SPLM.CAM.CutParametersIpwTypes = Object.freeze({
    "Thickness" : "Thickness", "None" : "None", "ThreeDimension" : "ThreeDimension", "LevelBased" : "LevelBased", "TwoDimension" : "TwoDimension", "UseReferenceTool" : "UseReferenceTool", "Local" : "Local"});

SPLM.CAM.CutParametersPatternDirectionTypes = Object.freeze({
    "Outward" : "Outward", "Inward" : "Inward", "Automatic" : "Automatic"});

SPLM.CAM.CutParametersCutConnectionTypes = Object.freeze({
    "Traverse" : "Traverse", "ContinuousCuts" : "ContinuousCuts"});

SPLM.CAM.CutParametersCleanupControlTypes = Object.freeze({
    "FollowShoulder" : "FollowShoulder", "CutToShoulder" : "CutToShoulder"});

SPLM.CAM.CutParametersProfileCutRegionsTypes = Object.freeze({
    "AutomaticDetection" : "AutomaticDetection", "SameAsRoughing" : "SameAsRoughing"});

SPLM.CAM.CutParametersFilletsTypes = Object.freeze({
    "AddIntoFaces" : "AddIntoFaces", "AddIntoDiameters" : "AddIntoDiameters", "Split" : "Split", "Omit" : "Omit"});

SPLM.CAM.CutParametersFinishPassesTypes = Object.freeze({
    "Maintain" : "Maintain", "Alternate" : "Alternate"});

SPLM.CAM.CutParametersCornerFindingTypes = Object.freeze({
    "WithinCutArea" : "WithinCutArea", "IncludeAdjacentPart" : "IncludeAdjacentPart", "ExtendOntoAdjacentPart" : "ExtendOntoAdjacentPart"});

SPLM.CAM.CutParametersExtendFloorTypes = Object.freeze({
    "None" : "None", "PartOutline" : "PartOutline", "BlankOutline" : "BlankOutline"});

SPLM.CAM.CutParametersToolRunOffTypes = Object.freeze({
    "ExtendToRegion" : "ExtendToRegion", "Specify" : "Specify"});

SPLM.CAM.CutParametersAdjacentBladesTypes = Object.freeze({
    "UseBladeStock" : "UseBladeStock", "UseCheckStock" : "UseCheckStock"});

SPLM.CAM.CutParametersExtendAtStartMode = Object.freeze({
    "None" : "None", "ToContainmentGeometry" : "ToContainmentGeometry", "IncludeAdjacentChamfersOrRounds" : "IncludeAdjacentChamfersOrRounds"});

export default SPLM;